/**
 * Parser for intersting details in predictions
 */
class GooglePrediction {
	/**
	 * @param  {Object} prediction
	 * @return {GooglePrediction}
	 */
	parse(prediction) {
		'use strict';
		this.id        = prediction.id;
		this.placeId   = prediction.place_id;

		//Get rid of the country
		prediction.terms.pop();

		this.terms     = prediction.terms;
		this.addresss  = prediction.description;
		return this;
	}

	/**
	 * @return {String}
	 */
	getAddress() {
		'use strict';
		return this.terms.map(function (term) {
			return term.value;
		}).join(', ');
	}

	/**
	 * @return {String}
	 */
	getPlaceId() {
		'use strict';
		return this.placeId;
	}
}

export default GooglePrediction;